import { useQuery } from '@tanstack/react-query'

import type { EntrySummary, Page } from '../../../shared/api'
import { api } from '../../../shared/api'
import type { EntryQuery } from '../entries.api.types'

export function useEntries(q: EntryQuery, enabled = true) {
  return useQuery({
    queryKey: ['entries', q],
    queryFn: () => api<Page<EntrySummary>>('/entries', { query: { ...q } }),
    placeholderData: (prev) => prev,
    enabled,
  })
}
